<template>
  <div class="main">
    <Board />
    <Deck />

    <v-dialog :value="isGameOver" persistent :max-width="300" content-class="game-over-dialog">
      <v-card class="text-center">
        <v-card-text class="pa-4">
          <h3>Game over!</h3>
          <h1 class="my-4">{{ score }}</h1>
          <v-row class="justify-center" no-gutters>
            <v-btn @click="playAgain" color="primary"> play again </v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <Scoreboard />
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as roomsHelpers from "@/helpers/rooms.js";

import Board from "../main/Board.vue";
import Deck from "../main/Deck.vue";
import Scoreboard from "./Scoreboard.vue";

export default {
  name: "Main",
  components: { Board, Deck, Scoreboard },
  computed: {
    ...mapState({
      room: (state) => state.room.room,
      isGameOver: (state) => state.room.room && state.room.room.status === "finished"
    }),
    score() {
      if (!this.room) return null;
      return this.room.score;
    }
  },
  methods: {
    playAgain() {
      if (!this.room) return;
      if (!this.isGameOver) return;
      roomsHelpers.clearRoom();
      window.location.reload();
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  margin-top: 48px;
  height: calc(100% - 48px);
  display: grid;
  grid-template-rows: 1fr 1fr;
  place-items: center;
  position: relative;
}

::v-deep .game-over-dialog {
  align-self: flex-end;
}
</style>
